var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 70,
    viewBox: "0 0 53 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63477 37.4713C2.63477 38.8467 2.79615 40.1242 2.97218 41.4821C3.16299 42.9541 3.12456 44.4893 3.12456 45.9719C3.12456 48.7422 3.16294 51.5228 3.02116 54.2875C2.79454 58.7066 2.73272 63.1148 2.73272 67.5446",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14453 30.6142C2.14453 30.7883 2.17174 30.8645 2.24249 31.006",
    stroke: "#4503B0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.958 18.3771C46.2752 15.1147 45.1829 12.3302 42.8176 10.0963C40.8072 8.19755 38.5928 8.02606 35.96 8.02606C32.4209 8.02606 29.869 11.6931 29.3468 14.8261C28.2893 21.1715 27.291 27.4742 27.291 33.9037C27.291 37.6548 27.5498 41.3828 27.5498 45.0886C27.5498 46.7694 28.0673 48.4889 28.0673 50.1491C28.0673 51.2761 27.9996 53.459 28.4555 54.462C28.8304 55.2868 28.8437 57.0505 28.8437 57.9699C28.8437 59.0912 28.8437 60.2126 28.8437 61.334C28.8437 63.4042 28.8437 65.4744 28.8437 67.5446",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1289 37.5266C24.1716 37.5266 33.3501 37.7853 42.3004 37.7853",
    stroke: "#1023DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIf);
export default __webpack_public_path__ + "static/media/IF.1be37da75fc76de17c0a61dbd9d550ea.svg";
export { ForwardRef as ReactComponent };